import { defineStore } from "pinia";
import { ref } from "vue";

var $_GET = {},
    args = location.search.substr(1).split(/&/);
for (var i=0; i<args.length; ++i) {
    var tmp = args[i].split(/=/);
    if (tmp[0] != "") {
        $_GET[decodeURIComponent(tmp[0])] = decodeURIComponent(tmp.slice(1).join("").replaceAll("+", " "));
    }
}

export const useDataFormStore = defineStore({
  id: "dataForm",
  state: () => ({
    cargoSpaceTabs: [
     {
       title: '1 место',
       name: '1',
       cargoWeight: 1,
       cargoVolume: 0.004,
       height: 10,
       length: 20,
       width: 20,
       diameter: 20,
       typeOfCargo: "Стандарт",
       additionalPackaging: true,
       typeOfPackaging: "",
       returnOfDocuments: false,
       cashOnDelivery: false,
       cashOnDeliverySum: null,
       typePowerOfAttorney: "",
       dataForTheDriver: false,
       sendTo: "",
       cargoRedemption: false,
       whoPaysTheRansom: "",
       cargoRedemptionSum: '',
       cargoCost: 3000,
       first_step_pass: false,
       natureOfCargo: [],
       natureOfCargoField: '',
       packageSpecs: "",
       counter: 0,
       errorNatureOfCargo: false,
     },
   ],
   packagesTabs: [
     {
       name: '1',
       typeOfPackagings: ref([]),
       additionalPackagingGroup: [],
       additionalPackagingGroupIds: [],
     }
   ],
   cargoInformationSliders: {
    cargoVolumeSlider: 1,
    cargoWeightSlider: 1,
   },
   cargoInformationSlidersTabs: [
    {
      name: '1',
      cargoVolumeSlider: 1,
      cargoWeightSlider: 1,
    }
   ],
   cargoOtherTabs: [
    {
      name: '1',
      warmPlace: false
    }
   ],
   packages: {
     additionalPackagingGroup: [],
     additionalPackagingGroupIds: [],
   },
   applicationCargoPickup: {
     isCargoPickup: false,
     addressCargoPickup: "",
     addressSelected: false,
     addressSelectedTo: false,
     pickupDate: "",
     addressCargoPickupNotice: "",
     addressCargoPickupNoticeTo: "",
     cargoStartTimePickup: "",
     cargoEndTimePickup: "",
     startTimeLunchBreak: "",
     endTimeLunchBreak: "",
     adressDetailRequired: false,
     adressDetailRequiredTo: false,
     deliveryDate: "",
  
     cargoStartTimeDelivery: "",
     cargoEndTimeDelivery: "",
     startTimeLunchBreakDelivery: "",
     endTimeLunchBreakDelivery: "",
  
     deliveryToTheAddress: false,
     addressConsignee: "",
  
     dataOnTheDriver: "",
     comment: "",
   },

   applicationCargoPickupTime: {
     cargoTimePickup: [],
     cargoTimePickupDelivery: [],
     cargoTimePickupRange: ref([]),
     cargoTimePickupRangeDelivery: ref([]),
   },
   
   sender: {
     first_step_pass: false,
     cityFrom: ($_GET['city_from']) ? $_GET['city_from'] :  "",
     officeFrom: '',
     officeFromEmpty: false,
     officeFromRefuse: false,
     senderType: 0,
     cargoPickUp: "Сдать на склад",
     innSender: "",
     kppSender: "",
     name: "",
     surnameSender: "",
     firstNameSender: "",
     secondNameSender: "",
     phoneSender: "",
     emailSender: "",
   },
  
   consignee: {
     cityTo: ($_GET['city_to']) ? $_GET['city_to'] :  "",
     officeTo: '',
     officeToEmpty: false,
     officeToRefuse: false,
     consigneeType: 0,
     cargoDelivery: "Забрать на складе",
     innConsignee: "",
     kppConsignee: "",
     name: "",
     surnameConsignee: "",
     firstNameConsignee: "",
     secondNameConsignee: "",
     phoneConsignee: "",
     emailConsignee: "",
   },
  
   thirdPerson: {
     cargoTransportationCustomer: "",
     typeThirdPerson: 0,
     innThirdPerson: "",
     kppThirdPerson: "",
     name: "",
     surnameThirdPerson: "",
     firstNameThirdPerson: "",
     secondNameThirdPerson: "",
     phoneThirdPerson: "",
     emailThirdPerson: "",
   },
  
   restrictions: {
     cityFromCategory: 1,
     cityToCategory: 1,
     weight: 99999,
     weightUnit: 99999,
     size: 99999,
     height: 99999,
     stockWeightFrom: 99999,
     stockSizeFrom: 99999,
     stockHeightFrom: 99999,
     stockWeightTo: 99999,
     stockSizeTo: 99999,
     stockHeightTo: 99999,
     maxCargoUnitWeightFrom: 99999,
     maxCargoUnitWeightTo: 99999,
   },
  
   cargoInformation: {
     cargoSpaceType: "simple",
     typeOfCargo: "Стандарт",
     numberOfIdenticalLoads: 1,
     cargoVolume: 0.004,
     cargoWeight: 1,
     cargoDimensions: {
       length: 20,
       width: 20,
       height: 10,
       diameter: 20,
     },
     sizeOfCargoCylinder: {
       diameter: 20,
       height: 10,
     },
     additionalPackaging: true,
     additionalPackagingGroup: [],
     additionalPackagingGroupIds: [],
     typeOfPackaging: "",
     natureOfCargo: [],
     natureOfCargoField: '',
   },
  
   services: {
     powerOfAttorney: false,
     typePowerOfAttorney: "",
     dataForTheDriver: false,
     sendTo: "",
     cashOnDelivery: false,
     cashOnDeliverySum: null,
     cargoRedemption: false,
     cargoRedemptionSum: null,
     whoPaysTheRansom: "",
     returnOfDocuments: false,
     packageSpecs: "",
     typeOfPackagings: ref([]),
   },
  
   payment: {
     whoPaysForCargoDelivery: "",
     typeOfPaymentForCargoDelivery: "",
     whoPaysForCargoPickup: "",
     typeOfPaymentForCargoPickup: "",
     whoPaysForCargoTransportation: "",
     typeOfPaymentForCargoTransportation: "",
     whoPaysForCargoExtraPacking: "",
     typeOfPaymentForCargoExtraPacking: "",
     isAgreeDataProcessing: false,
     isAgreeEmailMailing: false,
   },

   other: {
    cargoCost: 3000,
    payers: [
        {
            id: 0,
            counter: 0,
            person: "Отправитель",
            paymentType: "Наличные",
            services: {
                transport: true,
                delivery: true,
                pickup: true
            },
            disableCashless: false,
            error: '',
        },
    ],
   },
  
   calculator: {
     isCargoPickup: "Сдать на склад",
     isDelivery: "Забрать на складе",
   },
   applicationTimeIsOver: '14:00',
   cargoSpaceData: '1',
   showDistanation: true,
   showResult: true,
   selectedTab: 0,
   cityDataFrom: ref([]),
   cityDataTo: ref([]),
   cityDropdown: false,
   detailsDropdown: false,
   pageTitle: '',
   pageSendTitle: '',
   tabIndex: 1,
   tabIndexPayer: 1,
   windowShow: false,
   decalreWindowShow: false,
   windowError: '',
   firstCalc: false,
   cargoWatch: '',
   consigneeInnRadio: false,
   warmPlace: false,
   lkNotification: false,
   emailNotification: false,
   smsNotification: true,
   events: {
    selecting: false,
    requestEnd: false,
   },
   isOrderDone: false,
   // Устанавливается динамически из CargoPickupPage на основе активных табов
   totalSteps: 8,
   paymentAgreeStep: 7,
   // Вкладка «Способ оповещения» показывается только если текущее время >= этого значения.
   // Формат: ISO 8601 с временем и часовым поясом, например '2026-06-15T14:00:00+03:00'.
   // Пустая строка — таб показывается всегда.
   smsTabFromDate: '2026-06-01T00:00:00+05:00',
  }),
  actions: {
    updateApplicationTimeIsOver() {
      this.applicationTimeIsOver = this.getCheckingApplicationTimeIsOver
    }
  },
  getters: {
    getApplicationTimeIsOver(state) {
      return state.applicationTimeIsOver
    },

    getSmsTabEnabled(state) {
      if (!state.smsTabFromDate) return true;
      return new Date() >= new Date(state.smsTabFromDate);
    },

    isSpecialClient(state) {
      const SPECIAL_INN = '7448099122';
      const SPECIAL_KPP = '744701001';
      return (
        (state.sender.innSender === SPECIAL_INN && state.sender.kppSender === SPECIAL_KPP && state.thirdPerson.cargoTransportationCustomer === "Отправитель" && state.sender.senderType == 1) ||
        (state.consignee.innConsignee === SPECIAL_INN && state.consignee.kppConsignee === SPECIAL_KPP && state.thirdPerson.cargoTransportationCustomer === "Получатель" && state.consignee.consigneeType == 1) ||
        (state.thirdPerson.innThirdPerson === SPECIAL_INN && state.thirdPerson.kppThirdPerson === SPECIAL_KPP && state.thirdPerson.cargoTransportationCustomer === "Третье лицо" && state.thirdPerson.typeThirdPerson == 1)
      );
    },

    getCheckingApplicationTimeIsOver(state) {
      if (this.isSpecialClient) {
        return "23:00";
      }
      if(state.sender.cityFrom === "Челябинск") {
        if(state.cargoInformation.cargoWeight > 30) {
          const applicationTimeIsOver = "12:00"
          return applicationTimeIsOver
        }
        const applicationTimeIsOver = "15:00"
        return applicationTimeIsOver
       }
      if(state.sender.cityFrom === "Екатеринбург") {
        const applicationTimeIsOver = "12:00"
        return applicationTimeIsOver
       }
       const applicationTimeIsOver = "14:00"
      return applicationTimeIsOver
    }

  },
});
